export const escapeCsvValue = (value: any): string => {
    if (value === null || value === undefined) {
        return '';
    }
    const stringValue = String(value);
    if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

export const escapeTsvValue = (value: any): string => {
    if (value === null || value === undefined) {
        return '';
    }
    const stringValue = String(value);
    if (stringValue.includes('\t') || stringValue.includes('\n') || stringValue.includes('"')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
    }
    return stringValue;
};

export const copyToClipboard = (text: string, setPressed: (value: boolean) => void) => {
    navigator.clipboard.writeText(text);
    setPressed(true);
    setTimeout(() => setPressed(false), 200);
};

export const getJobIDFromReplyTarget = (replyTarget?: string) => {
    if (!replyTarget) return null;
    const parts = replyTarget.split('-');
    if (parts.length < 2) return null;
    return parts.slice(1).join('-');
};

